<template>
    <v-menu
        :ref="content"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        v-model="menu"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                :dense="dense"
                autocomplete="off"
                :value="formatedDate"
                @input="handleInputTextField"
                :label="label"
                hint="Formato DD/MM/YYYY"
                persistent-hint
                v-on="on"
                :disabled="readonly"
                v-on:keyup.enter="$emit('entered')"
                :background-color="error ? '#ff9898' : bckColor"
            ></v-text-field>
        </template>
        <v-date-picker
            :disabled="readonly"
            v-model="content"
            no-title
            color="primary"
            locale="es"
            @change="handleNewDate"
        ></v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "DatePicker",
        props:{
            value: String,
            label:String,
            readonly: {
                type: Boolean,
                required: false,
                default: false
            },
            dense: {
                type: Boolean,
                default: false,
            },
            error: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                menu: false,
                content: this.value,
                bckColor: "#ffffff", // error: #ff9898
            }
        },
        methods: {
            handleNewDate (e) {
                this.$emit('input', e);
                this.menu = false;
            },
            handleInputTextField(e) {
                let l = e.split('/');
                if (l.length==3 && l[2]!=='' && l[2].length==4 && l[1]!=='' && l[0]!=='') {
                    this.content = l[2]+'-'+l[1]+'-'+l[0];
                    if (Date.parse(this.content)) {
                        this.handleNewDate(this.content);
                        this.bckColor = "#ffffff";
                    } else { 
                        this.bckColor = "#ff9898";
                    }
                } else {
                    this.bckColor = "#ff9898";
                }
            },
        },
        computed:{
            formatedDate(){
                if (this.value && this.value !== '') {
                    this.value = this.value.split('T')[0];
                    let l = this.value.split("-");
                    return l[2]+'/'+l[1]+'/'+l[0];
                } else {
                    return "";
                }
            }
        },
    }
</script>

<style scoped>

</style>
